/**
 * 内存适配器：用于单元测试、演示模式，或未来做「预览沙箱」。
 * 同时可作为写云端适配器时的参照实现（逻辑最简单明了）。
 */
export class MemoryAdapter {
  constructor(seed = {}) {
    this.kind = 'memory';
    this._data = new Map();
    for (const [name, rows] of Object.entries(seed)) {
      this._data.set(name, new Map(rows.map(r => [r.id ?? r.key, structuredClone(r)])));
    }
  }

  _store(name) {
    if (!this._data.has(name)) this._data.set(name, new Map());
    return this._data.get(name);
  }

  async list(name) {
    // 注意：不能写 .map(structuredClone) —— map 会把索引当第二参数传进去，
    // structuredClone 会把它当 options 抛 TypeError。必须显式包一层。
    return [...this._store(name).values()].map(r => structuredClone(r));
  }
  async get(name, key) {
    const row = this._store(name).get(key);
    return row ? structuredClone(row) : null;
  }
  async put(name, value) {
    this._store(name).set(value.id ?? value.key, structuredClone(value));
    return value;
  }
  async bulkPut(name, values) {
    values.forEach(v => this._store(name).set(v.id ?? v.key, structuredClone(v)));
    return values.length;
  }
  async remove(name, key) { this._store(name).delete(key); }
  async bulkRemove(name, keys) { keys.forEach(k => this._store(name).delete(k)); return keys.length; }
  async clear(name) { this._store(name).clear(); }
  async count(name) { return this._store(name).size; }
  async query(name, index, value) {
    return [...this._store(name).values()].filter(r => r[index] === value).map(r => structuredClone(r));
  }
  async close() {}
}
